import { DevPowerBIMaintenanceModel } from "./../shared/dev-powerbi-model";
import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { firstValueFrom } from "rxjs";

@Injectable()
export class DevPowerBIService extends ApiDataService {
    constructor() {
        super("devpowerbi");
    }

    isEnabled() {
        return firstValueFrom(this.get<boolean>("/isenabled"));
    }

    getReports() {
        return firstValueFrom(this.get<DevPowerBIMaintenanceModel>());
    }

    updateReport(model: any) {
        return firstValueFrom(this.post<number>(model));
    }

    deleteReport(id: number) {
        return firstValueFrom(this.delete("/" + id));
    }

    createTemplates() {
        return this.post(null, "/templates/create");
    }
}